
import { configData as devEnvironment } from './config';

export function getAppConfig() {
    return devEnvironment;
}
